import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleModal} from "../../store/actions/toggleModalActions";
import ButtonSpinner from "../_common/ButtonSpinner";
import DatePicker from "react-datepicker";
import {addWarmHour, updateWarmHour} from "../../store/actions/warmHoursActions";
import ConfirmationModal from "../_common/ConfirmationModal";

const selector = state => {
    const { language, hours} = state;
    return {
        t: language.translator,
        selected: hours.selected.hour,
    }
};
const WarmHoursModal = props => {
    const dispatch = useDispatch();

    const { t,  selected, modalState } = useSelector(selector);
    const {edit} = props;

    const [formValues, setFormValues] = useState({})
    const [confirmUpdateModal, setConfirmUpdateModal] = useState(false);

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    useEffect(() => {
        if(edit) {
            setFormValues({
                    ...selected,
                startDate: new Date(selected.startDate)
            })
        }
    },[])

    const selectDate = (date) => {
        setFormValues({...formValues, startDate: date})
    }
    const handleAddWarmHourClick = () => {
        if(formValues.startDate && formValues.minTemperature) {
            if(edit) {
                dispatch(updateWarmHour(formValues))
            } else {
                dispatch(addWarmHour(formValues))
            }
            closeModal()
        }
    }

    return (
        <div
            className="fieldModalBlur">
            <div className='fieldModal'>
                <div className='fieldModalHeader'>
                    <div className='fieldModalTitleContainer'>
                        <div className='fieldModalTitle'>
                            {edit ? t.gettext('Edit Rising Hour') : t.gettext('Add Rising Hour')}
                        </div>
                    </div>
                    <div className='fieldModalCloseButtonHolder'>
                        <span
                            className='material-icons fieldModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='fieldModalContent'>
                    <form className='fieldForm' autoComplete='off'>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Name')}
                            </label>
                            <input
                                className='fieldFormInput'
                                onInput={e => {
                                    setFormValues({...formValues, configName: e.target.value});
                                }}
                                value={formValues.configName}
                                type='text'
                            />
                        </div>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Temperature')}
                            </label>
                            <input
                                className='fieldFormInput'
                                onInput={e => {
                                    setFormValues({...formValues, minTemperature: e.target.value});
                                }}
                                value={formValues.minTemperature}
                                type='number'
                            />
                        </div>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Start Date')}
                            </label>
                            <DatePicker
                                className="fieldFormInput dateInput"
                                dateFormat="dd/MM/yyyy"
                                selected={formValues.startDate ? formValues.startDate : null}
                                // inline
                                onChange={(date) => selectDate(date)}
                                // onChange={() => loadFields(selectedFilters)}
                            />
                        </div>
                        <div className='fieldButtonsHolder'>
                            <button
                                className='fieldAddButton fieldEditButton'
                                onClick={e => {
                                    e.preventDefault();
                                    edit ? setConfirmUpdateModal(true) : handleAddWarmHourClick()
                                }}
                            >
                                {t.gettext('Save')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {(edit && confirmUpdateModal) &&
                <ConfirmationModal
                    text={t.gettext('Are you sure?')}
                    deleteModal
                    closeMethod={() =>  setConfirmUpdateModal(false)}
                    confirmMethod={() => handleAddWarmHourClick()}
                    confirmButtonText={t.gettext('Save')}
                />
            }
        </div>
    )
}

export default WarmHoursModal
